import UserProfile from './UserProfile.vue';

export default UserProfile;
